export class CreateQuestionBankReqModel {
  classId: number;
  language: number;
  subject: number;
  chapter: number;
  topic: number;
  qno: number;
  questionType: number;
  difficultyLevel: number;
  marks: number;

  // Main question text (default language)
  question: string;

  // Multi-language versions
  questionEn: string;
  questionTe: string;
  questionUr: string;

  userName: string;
  approvedBy: string;
  timeStamp: string;
  etimeStamp: string;
  eStatus: number;
  name?: number;
  id?: number;

  constructor(
    classId: number,
    language: number,
    subject: number,
    chapter: number,
    topic: number,
    qno: number,
    questionType: number,
    difficultyLevel: number,
    marks: number,
    question: string,
    questionEn: string,
    questionTe: string,
    questionUr: string,
    userName: string,
    approvedBy: string,
    timeStamp: string,
    etimeStamp: string,
    eStatus: number,
    name?: number,
    id?: number,
  ) {
    this.classId = classId;
    this.language = language;
    this.subject = subject;
    this.chapter = chapter;
    this.topic = topic;
    this.qno = qno;
    this.questionType = questionType;
    this.difficultyLevel = difficultyLevel;
    this.marks = marks;

    this.question = question;
    this.questionEn = questionEn;
    this.questionTe = questionTe;
    this.questionUr = questionUr;

    this.userName = userName;
    this.approvedBy = approvedBy;
    this.timeStamp = timeStamp;
    this.etimeStamp = etimeStamp;
    this.eStatus = eStatus;
    this.name = name;
    this.id = id;
  }
}